import React from 'react';
import css from './index.module.scss';
import { BoxContainer, TextField } from '@components/common';
import { commodityInfo } from '@pages/order/generate-bill-of-lading/bol';

interface IProps {
  data: commodityInfo[] | null;
}

const CommodityInformation = (props: IProps) => {
  const { data } = props;
  return (
    <BoxContainer className={css.mainWrapper} title="Commodity Information">
      {(data || []).map((commodity, index) => (
        <div key={index} className={css.boxWrapper}>
          <div className={css.rowWrapper}>
            <TextField
              name={`productName-${index}`}
              label="Product Name"
              disabled
              value={commodity.productName}
              rootClassName={css.fieldWrapper}
            />
            <TextField
              name={`packageCount-${index}`}
              label="No of Packages"
              disabled
              value={commodity.packageCount.toString()}
              rootClassName={css.fieldWrapper}
            />
            <TextField
              name={`packageDescription-${index}`}
              label="Package Type"
              disabled
              value={commodity.packageDescription}
              rootClassName={css.fieldWrapper}
            />
            <TextField
              name={`netWeight-${index}`}
              label="Net Weight"
              disabled
              value={commodity.netWeight}
              rootClassName={css.fieldWrapper}
            />
          </div>
        </div>
      ))}
    </BoxContainer>
  );
};

export default CommodityInformation;
